export default "__VITE_ASSET__DTKtqb0A__"